import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { SettingsLayout } from '../components/SettingsLayout/SettingsLayout';

export const Routes = (): JSX.Element => {
	return (
		<Switch>
			<Route path="/" component={SettingsLayout} />
			<Redirect from="*" to={'/'} />
		</Switch>
	);
};
